//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import StockInventorySurplus from './StockInventorySurplus.vue'

export default {
  components: {
    StockInventorySurplus
  },
  props: {
    record: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      loading: false
    }
  },
  computed: {
    request: function () {
      return this.record.request
    }
  },
  created: function () {
  },
  methods: {
    onSave: function () {
      this.$emit('save')
    },
    onClose: function () {
      this.$emit('close')
    }
  }
}

